<template>
	<div class="ui-cart-wrapper">
		<!-- header -->
		<v-cart-header ref="header" :issShowTabbar="type" :isEmpty="isEmpty"></v-cart-header>
		<div v-if='!isEmpty'>
			<div class="order-header" @click="goRepurchase">
				<div class="order-header-item" id="order-item-left">
					<img class="order-header-icon" src="../../assets/image/change-icon/e1_order@2x.png" />
					<!-- <img class="order-header-icon" src="../../assets/image/change-icon/repurchase@2x.png" /> -->
					<label class="item-title order-header-title">换购</label>
				</div>
				<div class="order-header-item" id="order-item-right">
					<label class="order-subtitle">更多折扣,点击换购吧!</label>
					<img class="indicator" src="../../assets/image/change-icon/enter@2x.png" />
				</div>
			</div>
			<!-- list -->
			<v-cart-list ref='list' :issShowTabbar="type" :isCheckedAll="isFinish" :heigth="heigth"></v-cart-list>
			<!-- 促销 -->
			<!-- <v-cart-promos ref='promos' :issShowTabbar="type" :isCheckedAll="isFinish" :isshowpromos="isshowpromos"></v-cart-promos> -->
			<!-- footer -->
			<v-cart-footer :issShowTabbar="type" :isCheckedAll="isFinish" :isStatus="isStatus"></v-cart-footer>
		</div>
		<div v-if='isEmpty' class="empty-cart">
			<img src="../../assets/image/change-icon/cart_empty@2x.png">
			<p v-if="isOnline">您的购物车还是空的</p>
			<p v-if="!isOnline">登录后即可查看购物车中的商品</p>
			<span @click="goHome()" v-if="isOnline">随便逛逛</span>
			<span @click="goSingin()" v-if="!isOnline">去登录</span>
		</div>
	</div>
</template>

<script>
	import cartHeader from './child/CartHeader'
	import cartList from './child/CartList'
	import cartFooter from './child/CartFooter'
	import cartPromos from './child/Promos'
	import RepurChase from './child/RepurChase'
	import tabBar from '../../components/common/Tabbar';

	import { mapState, mapMutations } from 'vuex';

	export default {
		data(){
			return {
				type: parseInt(this.$route.params.type ? this.$route.params.type : 0),  //判断是否显示购物车底部的tabbar 1 ： 显示 0 不显示
				isFinish: false,  //编辑 false - 编辑~完成  true - 完成~编辑 false
				isStatus: true,  //是否默认选中底部的全选按钮
				isshowpromos: true,  //是否显示促销信息
				target: '',  //设置高度的element元素
				isEmpty: false,
				heigth: 0,
				
			}
		},

		computed: mapState({
			height: state => state.cart.height,  //TODO
			isOnline: state => state.auth.isOnline
		}),

		watch: {
			height: function (value) {
				let totalHeight = 44 + value;
				if (this.type) {
					totalHeight = totalHeight + 50;
				}
				this.heigth = totalHeight;
			}
		},

		created(){

			this.isSignin();

			// 监听是否改变购物车列表选中的状态
			this.$on('change-list-selected', (data) => {
				// data.isFinish ? 表示是完成状态，1，列表默认全不选中 2，促销信息不显示， 3，改变列表的高度  : 编辑状态  1，列表默认全选中 2，促销信息显示， 3，改变列表的高度
				if (!this.isEmpty) {
					this.isFinish = data.isFinish;
					if (data.isFinish) {
						this.isshowpromos = false;
						this.setHeight(0);
						this.$refs.list.addChecked(false);
					} else {
						this.isshowpromos = true;
						this.setHeight(this.height);
						this.$refs.list.addChecked(true);
					}
					this.$refs.list.renderCart();
				}
			});

			// 监听是否更新购物车列表
			this.$on('update-cart-list', (data) => {
				if (data.isdelete) {
					this.$refs.list.deleteSelected();
				}
			});

			// 监听是否获取购物车促销信息
			this.$on('get-promos-data', (data) => {
				// this.$refs.promos.getCartPromos(data);
			});

			// 监听购物车底部全选按钮是否选中
			this.$on('cart-bottom-status', (data) => {
				// if(this.$children[1].have_gift == 1){
				// 	this.isStatus = true;
				// 	return false;
				// }
				//data.isCheckAll ? true 1,显示促销信息， 2，重新计算列表的高度: false 1.隐藏促销信息， 2，重新计算列表的高度
				if (data.isCheckAll && !this.isFinish) {
					this.isshowpromos = true;
					this.setHeight(this.height);
				} else {
					this.isshowpromos = false;
					this.setHeight(0);
				}
				this.$refs.list.addChecked(data.isCheckAll);
				this.$refs.list.renderCart();
			});

			//监听列表一个个选中底部全选按钮默认选中
			this.$on('change-footer-status', (status) => {
				this.isStatus = status;
			});

			this.$on('list-is-empty', (data) => {
				if (data.cartList.length > 0 |  data.packageGood.length > 0) {
					this.isEmpty = false;
				} else {
					this.isEmpty = true;
				}
			});

			this.$on('product-validate', () => {
				this.$refs.list.productValidate();
			})
		},

		mounted(){
			// 计算内容高度
		    this.$nextTick( () => {
		    	this.target = document.querySelector('.cart-list-wrapper');
		    	let totalHeight = 44 + this.height;
				if (this.type) {
					totalHeight = totalHeight + 50;
				}
				this.heigth = totalHeight;
		    })
		},

		components: {
			'v-repur-chase':RepurChase,
			'v-cart-header': cartHeader,
			'v-cart-list': cartList,
			'v-cart-footer': cartFooter,
			'v-cart-promos': cartPromos,
			'v-cart-tabBar': tabBar
		},

		methods: {
			goRepurchase(){
				this.$router.push({ name: 'repurchase'});
			},
			// TODO
			setHeight(height) {
				let totalHeight = 44 + height;
				if (this.type) {
					totalHeight = totalHeight + 50;
				}
				this.heigth = totalHeight;
			},

			/*
			 * isSignin: 是否登录
			 */
			isSignin() {
				if (this.isOnline) {
					this.isEmpty = false;
				}else {
					this.isEmpty = true;
				}
			},

			/*
			 * goHome: 跳转到首页
			 */
			goHome() {
				this.$router.push({'name': 'home'});
			},

			goSingin() {
				this.$router.push({'name': 'signin'});
			}
		}
	}
</script>

<style lang='scss' scoped>
	.ui-cart-wrapper {
		.order-header {
			height: 44px;
			position: relative;
			top:46px;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-content: stretch;
			background-color: #fff;
			@include thin-border();
		}
		.order-header-item {
			flex: 1;
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		#order-item-left {
			justify-content: flex-start;
			margin-left: 10px;
		}
		#order-item-right {
			justify-content: flex-end;
		}
		.order-header-line {
			position: absolute;
			height: 1px;
			left: 10px;
			bottom: 0px;
			right: 10px;
			background-color: $lineColor;
		}
		.item-title {
			font-size: 16px;
			color: #4e545d;
		}
		.order-header-icon {
			width: auto;
			height: 20px;
		}
		.order-header-title {
			margin-left: 8px;
		}
		.indicator {
			width: 7px;
			height: 12 px;
			margin-left: 10px;
			margin-right: 10px;
		}
		.order-subtitle {
			font-size: 14px;
			color: #7c7f88;
		}
		.order-wrapper {
			height: 88px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: stretch;
			background-color: #fff;
		}
		.order-item {
			flex: 1;
		}
	}
	.empty-cart{
		  padding-top: 124px;
    	text-align: center;
    	img {
    		width: 75px;
    		height: 75px;
    	}
    	p {
	        font-size:16px;
	        color:rgba(124,127,136,1);
	        line-height:22px;
	        padding: 26px 0px 40px 0px;
    	}
    	span {
    		font-size:16px;
				color:rgba(255,255,255,1);
				height:44px;
				background:$primaryColor;
				border-radius: 3px ;
				line-height: 44px;
				display: inline-block;
				width: 200px;
    	}
	}
</style>



// WEBPACK FOOTER //
// src/page/cart/cart.vue